import React, { useEffect, useState } from 'react'
import FileViewer from 'react-file-viewer'
import {FormattedMessage, useIntl} from "react-intl"
import messages from "./messages"

const mimeToExt = {
  'application/pdf': 'pdf',
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'image/png': 'png',
  'image/jpeg': 'jpg',
}

export default function FilePreview({ fileId }) {
  const [objectUrl, setObjectUrl] = useState(null)
  const [fileType, setFileType] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    loadFile()

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [fileId])

  const loadFile = async () => {
    try {
      const res = await fetch(`/stream/task/file/${fileId}`)

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`)
      }

      const contentType = res.headers.get('Content-Type') || 'application/pdf'
      const blob = await res.blob()
      const url = URL.createObjectURL(blob)

      setObjectUrl(url)
      setFileType(mimeToExt[contentType] || contentType.split('/').pop())
    } catch (err) {
      setError(err)
    }
  }

  if (error) {
    return (
      <div>
        <FormattedMessage
          {...messages.error}
          values={{error: error.message}}
        />
      </div>
    )
  }
  if (!objectUrl) {
    return (
      <div>
        <FormattedMessage {...messages.loading} />
      </div>
    )
  }

  return (
    <div className='w-full h-full'>
      <FileViewer
        fileType={fileType}
        filePath={objectUrl}
        onError={(e) => console.error('Error viewing file:', e)}
      />
    </div>
  )
}
